import { render, staticRenderFns } from "./ReplacedSparePart.vue?vue&type=template&id=354a06ed"
import script from "./ReplacedSparePart.vue?vue&type=script&lang=js"
export * from "./ReplacedSparePart.vue?vue&type=script&lang=js"
import style0 from "./ReplacedSparePart.vue?vue&type=style&index=0&id=354a06ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports